import type { CSSProperties, PropsWithChildren } from 'react';

type ChipProps = PropsWithChildren<{
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
  filled?: boolean;
  textColor?: `text-${string}`;
  bgColor?: string;
  ringColor?: string;
  textSize?: string;
  padding?: string;
  rounded?: `rounded-${string}`;
}>;

export function Chip({
  children,
  className = '',
  style,
  onClick,
  filled = false,
  textColor = 'text-white',
  bgColor = 'bg-primary',
  ringColor = '',
  textSize = '',
  padding = 'px-3 py-1',
  rounded = 'rounded-[8px]',
}: ChipProps) {
  return (
    <span
      onClick={onClick}
      style={style}
      className={`${className} inline-flex items-center ${rounded} ${padding} ring-inset 
            ${textColor} ${bgColor} ${textSize} ${ringColor}
            ${filled ? '' : 'ring-1'} 
      `}
    >
      {children}
    </span>
  );
}
